class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
    window.scrollTo({ top: 0, behavior: 'auto' });
    if (this.input.value.trim() === '') {
      this.clearSearchResults();
      this.showCrossSell();
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
      this.clearSearchResults();
      this.showCrossSell();
    }
  }

  clearSearchResults() {
    const resultsList = document.querySelector('#search-autocomplete-results');
    if (resultsList) {
      resultsList.innerHTML = '';
    }
    
    const infiniteScroll = document.querySelector('infinite-scroll');
    if (infiniteScroll) infiniteScroll.remove();
    
    const newURL = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, newURL);

    const productGrid = document.querySelector('.template-search #ProductGridContainer');
    if (productGrid) productGrid.remove();

    const filters = document.getElementById('main-search-filters');
    if (filters) filters.remove();

    const facetsContainer = document.querySelector('.template-search .facets-container');
    if (facetsContainer) {
      facetsContainer.style.marginTop = '';
    }
  }
  
  showCrossSell() {
    const crossSell = document.getElementById('CrossSellCollection');
    if (crossSell) crossSell.style.display = '';
  }
}

customElements.define('search-form', SearchForm);



